import { IMusicProductDigitalAlbum } from 'services/music-product-digital/types/form';
import { IMusicProductDigitalTrackMutation } from 'services/music-product-digital/types/mutation';

export const convertAlbumsModelToTracks = (
  albums: IMusicProductDigitalAlbum[],
): IMusicProductDigitalTrackMutation[] =>
  albums
    .map((album, albumIndex) =>
      album.tracks.map((track, index) => ({
        trackId: track.id,
        albumNumber: albumIndex + 1,
        albumPlacement: index + 1,
      })),
    )
    .flat();
